class bodywashJS {
  constructor() {
    this.bodywash = document.querySelector("[data-body-wash]");
    console.log("bodywashJS---->>>", this.bodywash);
    if (!this.bodywash) {
      console.warn('No element found with [data-body-wash]');
      return;
    }
    
    const modalOpen = this.bodywash.querySelector("[data-modal-open]");
    if (modalOpen) {
      modalOpen.addEventListener('click', () => this._openPopUP());
    }

    const modalClose = this.bodywash.querySelector("[data-close]");
    if (modalClose) {
      modalClose.addEventListener('click', () => this._closePopUP());
    }

    document.querySelectorAll("[data-open-content]").forEach((ele) => {
      ele.addEventListener("click", (event) => this.opencontent(event));
    });
  }

  _openPopUP() {
    siteOverlay.prototype.showOverlay();
    document.querySelector("[view_incrediants_list]")?.classList.add("open");
  }

  _closePopUP() {
    siteOverlay.prototype.hideOverlay();
    document.querySelector("[view_incrediants_list]")?.classList.remove("open");
  }

  opencontent(event) {
    if (screen.width < 768) {
      event.currentTarget.classList.toggle("active");
    }
  }
}
new bodywashJS();

